class Message {
    state = {
        message: ''
    };
    showMessage(message: string) {
        this.state.message = message;
    }

    cleanMessage() {
        this.state.message = '';
    }
}

const store = new Message();
export default store;
